<template>
    <div class="accordion">
    <b-carousel
        id="carousel-fade"
        style="text-shadow: 0px 0px 2px #000"
        fade
        indicators
        img-width="1024"
        img-height="480"
    >
    <b-carousel-slide  v-for="image_file in imagefiles" :key="image_file.id" 
            :caption="image_file.description_file"
            :img-src="image_file.url_file"
    >
    </b-carousel-slide>

  </b-carousel>

        
    </div>
</template>

<script>
import { baseApiUrl } from '@/global'
import axios from 'axios'

export default {
    name: 'CarouselImage',
    props: ['objeto','objeto_id'],
    data: function() {
        return {
            imagefiles: [],
        
        }
    },
    methods: {
      async  loadImagefiles() {
          const url = `${baseApiUrl}/${this.objeto}/${this.objeto_id}`
            await axios(url).then(res => {
                this.imagefiles = res.data
            })
        },

    },
    mounted() {
        this.loadImagefiles()
    }
}
</script>

<style>
.accordion {
    font-size: 0.75rem;
}

.accordion button {
    font-size: 0.75rem;
}


.accordion input {
    font-size: 0.75rem;
}

</style>
